module.exports = __webpack_public_path__ + "assets/back-arrow-f854bb.svg";